import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/routing';
import { cn } from '@/utils/cn';

interface Props {
  isAccordionOpen?: boolean;
}

const GeneralInformation = ({ isAccordionOpen }: Props) => {
  const t = useTranslations('footer');

  return (
    <>
      <div className={cn('xl:hidden w-full flex flex-col gap-4 mt-6', isAccordionOpen && 'mt-3.5')}>

        <div className="text-c400 font-normal text-[0.75rem] leading-4 tracking-[0.0013rem] flex flex-col">
          <p>
            {t('legal.text1')}
            <Link href="mailto:support@sweepking.com" className="text-white transition-color duration-150 hover:text-primary-2 active:text-primary-2">support@sweepking.com</Link>
            .
            <br />
            <br />
            {t.rich('legal.text3', {
              terms: chunks => <Link href="/general-terms-of-use" className="text-white hover:text-primary-2 active:text-primary-2 tracking-[-0.0056rem]">{chunks}</Link>,
            })}
            .
            <br />
            <br />
            {t.rich('legal.text4', {
              terms: chunks => <Link href="/general-terms-of-use" className="text-white hover:text-primary-2 active:text-primary-2 tracking-[0.0063rem]">{chunks}</Link>,
              sweepstakes: chunks => <Link href="/sweepstakes-rules" className="text-white hover:text-primary-2 active:text-primary-2 tracking-[0.1px]">{chunks}</Link>,
            })}
          </p>

          <p className="text-c600/50 paragraph-xs-medium pt-4 max-lg:pb-17.5">
            {t('copyright')}
          </p>
        </div>

      </div>

      <div className="hidden xl:flex flex-col mt-10.75 text-c400 text-[0.75rem] xl:tracking-[0.02px] 3xl:mt-10.5 3xl:text-[0.875rem] 3xl:leading-5 leading-4 3xl:font-normal font-medium max-w-276.75 3xl:max-w-none">
        <p className="xl:tracking-[0.0004rem]">
          {t('legal.text1')}
          {' '}
          <Link
            href="mailto:support@sweepking.com"
            className="text-white transition-color duration-150 hover:text-primary-2 active:text-primary-2"
          >
            support@sweepking.com
          </Link>
          .
          <br />
          <br />
        </p>
        <p className="xl:tracking-0 3xl:tracking-0">
          {t.rich('legal.text3', {
            terms: chunks => (
              <Link href="/general-terms-of-use" className="text-white hover:text-primary-2 active:text-primary-2 3xl:tracking-[-0.2px]">
                {chunks}
              </Link>
            ),
          })}
          .
          <span className="xl:tracking-[-0.09px] 3xl:tracking-0">
            {t.rich('legal.text4', {
              terms: chunks => <Link href="/general-terms-of-use" className="text-white hover:text-primary-2 active:text-primary-2 xl:tracking-[0.0063rem] 3xl:tracking-[0.0125rem]">{chunks}</Link>,
              sweepstakes: chunks => <Link href="/sweepstakes-rules" className="text-white hover:text-primary-2 active:text-primary-2 tracking-[0.0063rem]">{chunks}</Link>,
            })}
            .
          </span>
        </p>
      </div>
    </>
  );
};

export default GeneralInformation;
